import Vue from 'vue';
import mandateProvider from '@/apiProviders/mandates/mandate.provider';
import mandatePropertyProvider from '@/apiProviders/mandates/mandateProperty.provider';
import Pagination from '@/viewModels/Pagination.class';
import OrderDirection from '@/consts/orderDirection.enum';
import statusConst from '@/consts/status.const.js';

const mandatePropertyModule = {
  namespaced: true,

  state: {
    property: {},
    propertiesList: [],
    propertiesListPagination: new Pagination(1, 50, 0, 'PropName', OrderDirection.DESC),
    textSearch: '',
    propertyStatus: statusConst.PENDING,
  },

  actions: {
    async fetchPropertyById({ commit }, propertyRowId) {
      commit('setPropertyStatus', statusConst.LOADING);

      try {
        const property = await mandatePropertyProvider.getPropertyById(propertyRowId);
        commit('setProperty', property);
        commit('setPropertyStatus', statusConst.SUCCESS);
      } catch (err) {
        commit('setPropertyStatus', statusConst.FAIL);
      }
    },

    async fetchPropertiesList({ commit, state, rootGetters }, RowId) {
      const { rows: propertiesList, nSkip, nTake, page } = await mandateProvider.getPropertiesByJobId(state.propertiesListPagination, RowId, state.textSearch);
      state.propertiesListPagination.pagination = { page, nTake, nSkip };

      commit('setPropertiesList', propertiesList);
    },

    setPropertiesListFilters({ commit }, filters) {
      commit('setPropertiesListFilters', filters);
    },

    resetPagination({ commit, state }) {
      const pagination = new Pagination(1, 50, 0, 'PropName', OrderDirection.DESC);
      commit('setPagination', pagination);
    },
  },

  mutations: {
    setProperty(state, payload) {
      Vue.set(state, 'property', payload);
    },
    setPropertiesList(state, payload) {
      Vue.set(state, 'propertiesList', payload);
    },
    setPropertiesListFilters(state, payload) {
      Vue.set(state, 'textSearch', payload);
    },
    setPagination(state, payload) {
      Vue.set(state, 'propertiesListPagination', payload);
    },
    setPropertyStatus(state, payload) {
      Vue.set(state, 'propertyStatus', payload);
    },
  },

  getters: {
    getPropertyAttribute: (state) => (attributeName) => {
      return state?.property?.attributes.find((attribute) => attribute.FeatureName === attributeName);
    },
  },
};

export default mandatePropertyModule;
